import { useState, useEffect } from "react";
import { getDictByKind } from "../server/Category";

let cachedVisibleIds = null;
let cachedVisibleNames = null;
let loadPromise = null;

const buildVisibilitySets = (items) => {
  const ids = new Set();
  const names = new Set();
  (items || []).forEach((item) => {
    if (item?.showInProduct !== true) return;
    if (item.id) ids.add(item.id);
    if (item.name) names.add(item.name);
  });
  return { ids, names };
};

const loadVisibility = () => {
  if (cachedVisibleIds && cachedVisibleNames) {
    return Promise.resolve({
      ids: cachedVisibleIds,
      names: cachedVisibleNames,
    });
  }
  if (!loadPromise) {
    loadPromise = getDictByKind("kashrut-feature")
      .then((data) => {
        const { ids, names } = buildVisibilitySets(data);
        cachedVisibleIds = ids;
        cachedVisibleNames = names;
        return { ids, names };
      })
      .catch(() => {
        loadPromise = null;
        return { ids: new Set(), names: new Set() };
      });
  }
  return loadPromise;
};

/** Returns whether a product kashrutFeature should display (dict showInProduct). */
export const useKashrutFeatureShowInProduct = (kashrutFeature) => {
  const [visible, setVisible] = useState(false);
  const id =
    kashrutFeature && typeof kashrutFeature === "object"
      ? kashrutFeature.id
      : undefined;
  const name =
    kashrutFeature && typeof kashrutFeature === "object"
      ? kashrutFeature.name
      : kashrutFeature || undefined;

  useEffect(() => {
    let cancelled = false;

    if (!id && !name) {
      setVisible(false);
      return undefined;
    }

    loadVisibility().then(({ ids, names }) => {
      if (cancelled) return;
      setVisible(
        (id != null && ids.has(id)) || (name != null && names.has(name)),
      );
    });

    return () => {
      cancelled = true;
    };
  }, [id, name]);

  return visible;
};
